import "./navbar.css";

import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

import logo from "../../img/logo/favicon.png";
import menu from "../../img/icons/menu.svg";
import instagram from "../../img/icons/instagram.png";
import tiktok from "../../img/icons/tik-tok.png";

function Navbar() {
  const location = useLocation();
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      // Change background when scrolled more than 50px
      setIsScrolled(scrollTop > 50);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const openNavbar = (event) => {
      if (event.target.tagName !== "BUTTON") {
        setIsNavbarOpen(false);
      }
    };

    document.addEventListener("click", openNavbar);

    return () => {
      document.removeEventListener("click", openNavbar);
    };
  }, []);

  return (
    <header className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-box">
        <Link
          to="/"
          className="navbar-logo"
          onClick={() => {
            window.scroll(0, 0);
          }}
        >
          <img src={logo} alt="logo"></img>
          <p>RAZOR KING</p>
        </Link>

        <ul className="navbar-links">
          <li>
            <Link to="/" className={location.pathname === "/" ? "active" : ""}>
              HOME
            </Link>
          </li>
          <li>
            <Link
              to="/services"
              className={location.pathname === "/services" ? "active" : ""}
            >
              SERVICES
            </Link>
          </li>
          <li>
            <Link
              to="/team"
              className={location.pathname === "/team" ? "active" : ""}
            >
              OUR TEAM
            </Link>
          </li>
          <li>
            <Link
              to="/locations"
              className={location.pathname === "/locations" ? "active" : ""}
            >
              LOCATIONS
            </Link>
          </li>
        </ul>

        <ul className="social-links">
          <li>
            <Link to="https://www.instagram.com/razorking.ca">
              <img src={instagram} alt="instagram"></img>
            </Link>
          </li>
          <li>
            <Link to="/" className="inactive">
              <img src={tiktok} alt="tiktok"></img>
            </Link>
          </li>
        </ul>

        <button
          className="navbar-mobile-button"
          onClick={() => setIsNavbarOpen(true)}
        ></button>
      </div>

      <div
        className="navbar-mobile"
        style={{
          transform: isNavbarOpen ? "translateY(0)" : "translateY(-100vh)",
          transition: "200ms",
        }}
      >
        <ul className="navbar-mobile-links">
          <li>
            <Link to="/" className={location.pathname === "/" ? "active" : ""}>
              HOME
            </Link>
          </li>

          <li>
            <Link
              to="/services"
              className={location.pathname === "/services" ? "active" : ""}
            >
              SERVICES
            </Link>
          </li>

          <li>
            <Link
              to="/team"
              className={location.pathname === "/team" ? "active" : ""}
            >
              OUR TEAM
            </Link>
          </li>

          <li>
            <Link
              to="/locations"
              className={location.pathname === "/locations" ? "active" : ""}
            >
              LOCATIONS
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Navbar;
